var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 18",
    width: 17,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-37-94h428v6281h-428z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#f457b0;stroke-width:2}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m15.5 16.7l-4.4-4.4c-1.2 0.9-2.6 1.4-4.2 1.4-3.8 0-6.9-3-6.9-6.8 0-3.8 3.1-6.9 6.9-6.9 3.8 0 6.8 3.1 6.8 6.9 0 1.6-0.5 3-1.4 4.2l4.4 4.4c0.4 0.3 0.4 0.9 0 1.2q-0.2 0.3-0.6 0.3-0.3 0-0.6-0.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8e4da9088c4e54d2a5eac84b073749b6.svg";
export { ForwardRef as ReactComponent };